export default (initialState = {}) => {
  return () => {
    return {
      date: null,
      gen_cn_dn: false,
      invc_id: null,
      invc_number: "",
      lineitems: [],
      number: "",
      po_id: null,
      pod_id: null,
      status_cd: "passed",
      status: "Passed",
      remarks: "",
      tcs: {},
      tds: {},
      total_amount: 0,
      total_tax: 0,
      vehicle_number: "",
      ...initialState,
    };
  };
};
